import Button from 'ext-ui/components/Button/Button'
import Pill, { PillProps } from 'ext-ui/components/Pill/Pill'
import React from 'react'
import * as style from 'src/app/CardFeedDetails/components/CardFeedDetailsHeaderTitle.style'
import SvgPencilIcon from 'src/components/Svgs/SvgPencilIcon'
import { useTranslate } from 'src/localization/Trns'
import { CardFeedStatus } from 'src/queries/cardFeeds/cardFeeds.models'

type NonConnectedStatus = Exclude<CardFeedStatus, 'ACTIVE'>

// Localized status copy for feeds that are not connected; keys exist in
// en-US.json.
const STATUS_LABEL: Record<NonConnectedStatus, string> = {
  SUBMITTED: 'Pending',
  FAILED: 'Failed',
  DEACTIVATED: 'Disconnected',
}

// undefined → the Pill's default grey.
const STATUS_PILL_COLOR: Record<NonConnectedStatus, PillProps['color']> = {
  SUBMITTED: 'pending',
  FAILED: 'severe',
  DEACTIVATED: undefined,
}

interface CardFeedDetailsHeaderTitleProps {
  name: string
  status: CardFeedStatus
  // The API may omit the reference id; the ID tag is hidden when it's absent.
  referenceId: string | null | undefined
}

const CardFeedDetailsHeaderTitle: React.FC<CardFeedDetailsHeaderTitleProps> = ({
  name,
  status,
  referenceId,
}) => {
  const translate = useTranslate()
  const isConnected = status === 'ACTIVE'

  return (
    <span css={style.title}>
      <span>{name}</span>
      {isConnected && (
        <Button
          variant="text"
          // No-op for now — the edit flow ships in a follow-up.
          onClick={(): void => undefined}
          aria-label={translate('Edit card feed')}
          data-testid="card-feed-details-edit"
          css={style.editButton}
        >
          <SvgPencilIcon width={20} height={20} viewBox="0 0 16 16" />
        </Button>
      )}
      {isConnected ? (
        referenceId && (
          <Pill data-testid="card-feed-details-id">
            {translate('ID: ${id}', { id: referenceId })}
          </Pill>
        )
      ) : (
        <Pill
          color={STATUS_PILL_COLOR[status]}
          data-testid="card-feed-details-status"
        >
          {translate(STATUS_LABEL[status])}
        </Pill>
      )}
    </span>
  )
}

export default CardFeedDetailsHeaderTitle
